import { render, staticRenderFns } from "./cotinine-cot-rapid-test_pc.vue?vue&type=template&id=c4eb6194&scoped=true&"
import script from "./cotinine-cot-rapid-test_pc.vue?vue&type=script&lang=js&"
export * from "./cotinine-cot-rapid-test_pc.vue?vue&type=script&lang=js&"
import style0 from "./cotinine-cot-rapid-test_pc.vue?vue&type=style&index=0&id=c4eb6194&scoped=true&lang=less&"
import style1 from "./cotinine-cot-rapid-test_pc.vue?vue&type=style&index=1&id=c4eb6194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4eb6194",
  null
  
)

export default component.exports